import React, { useContext, useEffect, useState } from 'react';
import { Loan, Task, TaskResponse, TaskState } from 'gql/graphql';
import { useCreateResponseTask } from 'services/task/mutations';
import { Button } from 'antd';
import { SubmitContext, TaskContext } from '../EntityGuarantorCreation';
import { useCreateEntity } from 'services/entity/mutations';
import { LoanContext } from 'scenes/Private/Dashboard/Dashboard';
import moment from 'moment';
import ErrorBox from 'components/Atoms/Alerts/ErrorBox';
import alertIcon from 'assets/images/alert-triangle.svg';

interface Step2Props {
  ownerships: any[];
  entity?: { key: string; name: string };
  step2Confirm?: any;
  newOwner: any;
  responseStep1: TaskResponse;
  taskEntityDocs?: Task;
  messageErrorDisabled?: string;
}
const ButtonSubmit = ({
  ownerships,
  entity,
  step2Confirm,
  newOwner,
  responseStep1,
  taskEntityDocs,
  messageErrorDisabled
}: Step2Props) => {
  const task: Task | any = useContext(TaskContext);
  const loan: Loan | any = useContext(LoanContext);
  const onSubmitParent: { step?: number; active?: boolean } | any =
    useContext(SubmitContext);

  const { fetching, execute: createResponseTask } = useCreateResponseTask();
  const { execute: createEntity } = useCreateEntity();
  const [showErrorBox, setShowErrorBox] = useState(false);

  useEffect(() => {
    if (onSubmitParent.active && onSubmitParent.step === 2) submitOwnerships();
  }, [onSubmitParent]);

  const getTotal = () =>
    ownerships
      .reduce(
        (total: number, ownership: any) => total + ownership.ownership,
        0
      );

  useEffect(() => {
    if (!step2Confirm || getTotal() === 100) setShowErrorBox(false);
  }, [step2Confirm, getTotal()]);

  const submitOwnerships = () => {
    createResponseTask({
      task: task._id,
      key: `complete-ownerships`,
      label: `Add 100% ownership to submit`,
      step: 3,
      metadata: {},
      state: TaskState.Approved
    });

    createEntity({
      _id:
        responseStep1.label === 'Existing entity'
          ? responseStep1.key
          : undefined,
      name: entity?.name || `Entity created on ${moment().format('DD/MM/YY')}`,
      loans: [loan._id],
      task: task._id
    });
  };

  if (newOwner)
    return null;

  return (
    <>
      <div style={{ position: 'relative', width: '100%' }}>
        <Button
          className="button button-submit"
          onClick={submitOwnerships}
          disabled={getTotal() !== 100 && !step2Confirm}
          loading={fetching}
        >
          {step2Confirm
            ? 'Confirm ownership'
            : getTotal() !== 100
              ? 'Add 100% ownership to submit'
              : 'Create entity and complete profiles'
          }
        </Button>
        {getTotal() !== 100 && !step2Confirm && (
          <div
            onClick={() => setShowErrorBox(true)}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              cursor: 'not-allowed',
              backgroundColor: 'transparent'
            }}
          />
        )}
      {showErrorBox && messageErrorDisabled && (
        <ErrorBox text={messageErrorDisabled} img={alertIcon} className='mt-10' />
      )}
      </div>
    </>
  );
};
export default ButtonSubmit;
